/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const dentalTreatmentRecords = sqliteTable('dental_treatment_records', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  patient_id: text('patient_id'),
  encounter_id: text('encounter_id'),
  dental_treatment_id: text('dental_treatment_id'),
  treatment: text('treatment'),
  notes: text('notes'),
  performed_at: text('performed_at'),
  performed_by: text('performed_by'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  updated_by: text('updated_by'),
});
